<div class="main">
  <app-header
    [nextAvailable]="false"
    [cancelAvailable]="false"
    [isMobileApp]="isMobileApp"
  >
  </app-header>

  <div
    class="d-flex flex-column align-items-center justify-content-start main-top"
  >
    <div
      id="surveyElement"
      class="d-flex flex-row align-items-center justify-content-center m-auto px-4"
    ></div>
    <div
      class="d-flex flex-row align-items-center justify-content-center m-auto"
    >
      <app-help [requestID]="requestID"></app-help>
    </div>
  </div>
</div>

